let listeners = [];
export var RemoteStatus;
(function (RemoteStatus) {
    RemoteStatus["ready"] = "ready";
    RemoteStatus["error"] = "error";
    RemoteStatus["initializing"] = "initializing";
})(RemoteStatus || (RemoteStatus = {}));
let remotes = {};
function updateOrInitializeRemote(key, newValues) {
    remotes = {
        ...remotes,
        [key]: {
            ...remotes[key],
            ...newValues,
            // Handle the entries array specifically
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            entries: { ...remotes[key]?.entries, ...newValues.entries },
        },
    };
}
export const remoteStore = {
    setRemoteReady(remote, entry) {
        const entryObject = { [entry]: RemoteStatus.ready };
        updateOrInitializeRemote(remote, { entries: entryObject });
        emitChange();
    },
    setRemoteError(remote, entry) {
        const entryObject = { [entry]: RemoteStatus.error };
        updateOrInitializeRemote(remote, { entries: entryObject });
        emitChange();
    },
    setRemoteInitializing(remote, entry) {
        const entryObject = { [entry]: RemoteStatus.initializing };
        updateOrInitializeRemote(remote, { entries: entryObject });
        emitChange();
    },
    // setUrls(remoteUrls) {
    //   remotes = { ...remotes, ...remoteUrls };
    //   emitChange();
    // },
    setConfig(remote, config) {
        updateOrInitializeRemote(remote, { config });
        emitChange();
    },
    subscribe(listener) {
        listeners = [...listeners, listener];
        return () => {
            listeners = listeners.filter(l => l !== listener);
        };
    },
    getSnapshot() {
        return remotes;
    },
};
function emitChange() {
    listeners.forEach(listener => listener());
}
